//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableEmptyData from '@/components/Shared/Table/TableEmptyData'
import Tag from '@/components/Shared/Tag'
import ModalDeleteUser from '@/components/Projects/users/ModalDeleteUser.vue'
import Button from '@/components/Shared/Button'
import { SECTIONS } from '~/constants/questionary'

export default {
  name: 'QuizProgressList',
  components: {
    TableEmptyData,
    Tag,
    ModalDeleteUser,
    Button,
  },
  filters: {
    completenessStyleForActiveRow(questionary) {
      return SECTIONS.FINISH === questionary?.section
        ? 'is-success'
        : 'is-danger'
    },
    completenessCustomStyleForActiveRow(questionary) {
      return SECTIONS.FINISH === questionary?.section
        ? 'custom-is-success'
        : 'custom-is-danger'
    },
    completenessTextForActiveRow(questionary) {
      const postFix = questionary?.postFix
        ? ` cuest.${questionary?.postFix}`
        : ''
      return SECTIONS.FINISH === questionary?.section
        ? 'Completo' + postFix
        : 'Incompleto' + postFix
    },
    fullNames(user) {
      return `${user?.names} ${user?.lastnames}`
    },
  },
  props: {
    data: {
      default: () => [],
      type: Array,
    },
    total: {
      default: 0,
      type: Number,
    },
    totalPending: {
      default: 0,
      type: Number,
    },
    perPage: {
      default: 10,
      type: Number,
    },
    project: {
      type: Object,
      default: () => ({}),
    },
    allUsers: {
      type: Array,
      default: () => [],
    },
    existsModelQuestionary: {
      type: Boolean,
      default: false,
    },
    existsActiveQuestionary: {
      type: Boolean,
      default: false,
    },
    isEnabledMatchPotential: {
      type: Boolean,
      default: false,
    },
    isEnabledReassessment: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      selectedRowIndex: -1,
      userToDelete: {},
      isShowModalDeleteUsers: false,
      duplicateEmails: [],
      duplicateAll: false,
    }
  },
  computed: {
    showSelectMassive() {
      return this.duplicateEmails.length > 0
    },
    showUsersAndAction() {
      if (this.duplicateAll) {
        return {
          users: this.totalPending,
          message: 'Anular selección',
        }
      }
      return {
        users: this.duplicateEmails.length,
        message: `Seleccionar los ${
          this.totalPending - this.duplicateEmails.length
        } usuarios restantes`,
      }
    },
    isDisabled() {
      return this.duplicateEmails.length === 0
    },
    showActiveQuestionary() {
      return this.existsActiveQuestionary && this.isEnabledMatchPotential
    },
    isPartialSelected() {
      return this.duplicateEmails.length > 0 && !this.duplicateAll
    },
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page
      this.$emit('on-page-change', page)
      this.duplicateEmails = []
      this.duplicateAll = false
    },
    onRowChecked(data) {
      this.duplicateEmails = data
      this.$emit('on-row-checked', data)
      this.duplicateAll = this.duplicateEmails.length === this.totalPending
    },
    selectedAllEmails() {
      if (this.duplicateAll) {
        this.duplicateEmails = []
      } else {
        this.duplicateEmails = this.data.filter((row) =>
          this.isEnableCheckbox(row)
        )
      }
      this.duplicateAll = !this.duplicateAll
    },
    toggleDropdown(index) {
      if (this.selectedRowIndex === index) {
        this.selectedRowIndex = -1
      } else {
        this.selectedRowIndex = index
      }
    },
    toggleModalDeleteUsers() {
      this.isShowModalDeleteUsers = !this.isShowModalDeleteUsers
    },
    setTimeoutDisabled(user, state, time = 0) {
      setTimeout(() => {
        user.disabled = state
        this.$forceUpdate()
      }, time)
    },
    async resendInvitation(user) {
      this.setTimeoutDisabled(user, true)
      await this.$repository.invitation
        .collaboratorEmployeeProgressQuestionaryReminderInvitation({
          usersIds: [user.id],
          projectId: this.project.id,
        })
        .finally(() => {
          this.setTimeoutDisabled(user, false, 5000)
        })
    },
    async deleteUserConfirmed(userToDelete) {
      this.$store.commit('loading', true)
      const usersIds = this.allUsers
        .filter((user) => user.id !== userToDelete.id)
        .map((user) => user.id)
      await this.$repository.project.update(this.$route.params.id, {
        users: usersIds,
        total_users: usersIds.length,
      })
      this.$store.commit('project/SET_TOTAL_USERS', usersIds.length)
      this.$emit('user-deleted')
    },
    isEnableCheckbox(row) {
      if (!this.isEnabledReassessment) {
        return false
      }
      // Si existe cuestionario activo, debe estar completo
      const activeComplete =
        !this.existsActiveQuestionary ||
        row.currentQuestionary?.section === SECTIONS.FINISH

      // Si existe cuestionario modelo, debe estar completo
      const modelComplete =
        !this.existsModelQuestionary ||
        row.modelQuestionary?.section === SECTIONS.FINISH

      // Ambos deben cumplirse
      return activeComplete && modelComplete
    },
    isAnyCheckboxEnabled() {
      return this.data.some((row) => this.isEnableCheckbox(row))
    },
    async duplicateQuestionaries() {
      const usersIds = this.duplicateEmails.map((user) => user.id)
      try {
        this.$store.commit('loading', true)
        if (this.existsActiveQuestionary) {
          await this.$repository.questionary.duplicateByProject(
            this.project.id,
            usersIds
          )
        }
        if (this.existsModelQuestionary) {
          await this.$repository.modelQuestionary.duplicateByProject(
            this.project.id,
            usersIds
          )
        }
        this.$buefy.notification.open({
          message: `<p>Cuestionarios duplicados exitosamente para ${usersIds.length} usuarios.</p>`,
          type: 'is-success',
          queue: false,
          hasIcon: true,
          duration: 7000,
        })
        this.duplicateEmails = []
        this.duplicateAll = false
      } catch (error) {
        this.$buefy.notification.open({
          message: error.message,
          type: 'is-danger',
          hasIcon: true,
          duration: 7000,
        })
      } finally {
        this.$emit('get-employees-in-project')
        this.$store.commit('loading', false)
      }
    },
  },
}
